export default __webpack_public_path__ + "static/media/search.eaca8bf5.svg";